<template>
  <div
    :class="[
      'p-5 py-3 border-t border-neutral200 fixed bottom-0 left-0 w-screen pb-5 bg-white',
      'tablet:static tablet:w-auto tablet:z-auto',
    ]"
  >
    <slot></slot>
  </div>
</template>
